/* istanbul ignore file */
import { CSSProperties } from 'react';
import { DropdownMenuItem } from '@bst/react-ui';

type Props = {
  style?: CSSProperties
}

/**
 * Loading skeleton animation component for CellFilter dropdown menu
 */
export const CellFilterLoading = ({ style }: Props) => (
  <DropdownMenuItem
    tabIndex={undefined}
    onSelect={(event) => event.preventDefault()}
    style={style}
  >
    <div className="loading-animation" data-testid="loading-animation" />
  </DropdownMenuItem>
);
